import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ size = 'medium', text = 'Loading...' }) => {
  const spinnerSize = size === 'small' ? 'spinner-small' : 
                      size === 'large' ? 'spinner-large' : 'spinner-medium';
  
  return (
    <div className="spinner-container">
      <div className={`spinner ${spinnerSize}`}></div>
      {text && <p className="spinner-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;
